import { isValueString } from '@/composables/helpers/useStringHelpers';
import { isObject } from '@vueuse/core';

import { i18n } from '@/packages/i18n';

const { t } = i18n.global;

// map centry names to app routes
export const IDENTITY_MAPPING_ROUTES = {
  BANXA: {
    PERSONAL_DETAILS: {
      name: t('IdentityQueueStore.name.upNextBillingDetails'),
      route: '/identity/identityConfirmation',
    },
    POA: {
      name: t('IdentityQueueStore.name.upNextProofOfAddress'),
      route: '/identity/proofOfAddress',
    },
    SOURCE_FUNDS: {
      name: t('IdentityQueueStore.name.upNextSof'),
      route: '/identity/sourceOfFunds',
    },
    PURPOSE_OF_TX: {
      name: t('IdentityQueueStore.name.upNextPurposeOfTransaction'),
      route: '/identity/purposeOfTransaction',
    },
    SOF_DOCUMENT: {
      name: t('IdentityQueueStore.name.upNextSofDocUpload'),
      route: '/identity/sofDocumentUpload',
    },
    DOCUMENT: {
      name: t('IdentityQueueStore.name.upNextDocUpload'),
      route: '/identity/idUpload/nationalDriversLicence',
    },
    DOCUMENT_NUMBER: {
      name: t('IdentityQueueStore.name.upNextDocNumber'),
      route: '/identity/documentNumber',
    },
    SELFIE: {
      name: t('IdentityQueueStore.name.upNextSelfieDocUpload'),
      route: '/identity/selfie',
    },
    OCCUPATION: {
      name: t('IdentityQueueStore.name.upNextOccupation'),
      route: '/identity/occupation',
    },
    PEP_SOURCE_FUNDS: {
      name: t('IdentityQueueStore.name.upNextPepSof'),
      route: '/identity/pepSourceOfFunds',
    },
    PEP_SOF_DOCUMENT: {
      name: t('IdentityQueueStore.name.upNextPepSofDoc'),
      route: '/identity/pepSofDocumentUpload',
    },
    US_TAX_ID: {
      name: t('IdentityQueueStore.name.upNextSSN'),
      route: '/identity/ssn',
    },
    DLOCAL_CPF: {
      name: t('IdentityQueueStore.name.upNextDlocalCpf'),
      route: '/identity/dlocal/cpf',
    },
    DLOCAL_SAID: {
      name: t('IdentityQueueStore.name.upNextDlocalSaid'),
      route: '/identity/dlocal/said',
    },
    DLOCAL_CURP: {
      name: t('IdentityQueueStore.name.upNextDlocalCurp'),
      route: '/identity/dlocal/curp',
    },
    DLOCAL_DNI: {
      name: t('IdentityQueueStore.name.upNextDlocalDni'),
      route: '/identity/dlocal/dni',
    },
    DLOCAL_CC: {
      name: t('IdentityQueueStore.name.upNextDlocalCc'),
      route: '/identity/dlocal/cc',
    },
    DLOCAL_CI: {
      name: t('IdentityQueueStore.name.upNextDlocalCi'),
      route: '/identity/dlocal/ci',
    },
    DLOCAL_TIC: {
      name: t('IdentityQueueStore.name.upNextDlocalTic'),
      route: '/identity/dlocal/tic',
    },
    WALLET_OWNERSHIP: {
      name: t('IdentityQueueStore.name.upNextWalletOwnership'),
      route: '/identity/walletOwnership',
    },
    DOFP_QUESTIONNAIRE_BUY_1: {
      name: t('IdentityQueueStore.name.upNextDofpQuestionnaire1'),
      route: '/identity/dofp/questionnaire/buy/1',
    },
    DOFP_QUESTIONNAIRE_BUY_2: {
      name: t('IdentityQueueStore.name.upNextDofpQuestionnaire2'),
      route: '/identity/dofp/questionnaire/buy/2',
    },
    DOFP_QUESTIONNAIRE_BUY_3: {
      name: t('IdentityQueueStore.name.upNextDofpQuestionnaire3'),
      route: '/identity/dofp/questionnaire/buy/3',
    },
    DOFP_QUESTIONNAIRE_SELL_1: {
      name: t('IdentityQueueStore.name.upNextDofpQuestionnaire1'),
      route: '/identity/dofp/questionnaire/sell/1',
    },
    DOFP_QUESTIONNAIRE_SELL_2: {
      name: t('IdentityQueueStore.name.upNextDofpQuestionnaire2'),
      route: '/identity/dofp/questionnaire/sell/2',
    },
    DOFP_QUESTIONNAIRE_SELL_3: {
      name: t('IdentityQueueStore.name.upNextDofpQuestionnaire3'),
      route: '/identity/dofp/questionnaire/sell/3',
    },
    CATEGORY: {
      name: t('IdentityQueueStore.name.upNextInvestorCategorisation'),
      route: '/identity/dofp/investor-declaration',
    },
    COOLING_OFF: {
      name: t('IdentityQueueStore.name.upNextCoolingOff'),
      route: '/identity/dofp/cooling-period',
    },
    UPDATE_DETAILS: {
      name: t('IdentityQueueStore.name.updateDetails'),
      route: '/identity/confirm-details',
    },
  },
  SUMSUB: {
    PERSONAL_DETAILS: {
      name: t('IdentityQueueStore.name.upNextBillingDetails'),
      route: '/identity/identityConfirmation',
    },
    POA: {
      name: t('IdentityQueueStore.name.upNextProofOfAddress'),
      route: '/identity/sumsub',
    },
    SOURCE_FUNDS: {
      name: t('IdentityQueueStore.name.upNextSof'),
      route: '/identity/sumsub',
    },
    PURPOSE_OF_TX: {
      name: t('IdentityQueueStore.name.upNextPurposeOfTransaction'),
      route: '/identity/sumsub',
    },
    SOF_DOCUMENT: {
      name: t('IdentityQueueStore.name.upNextSofDocUpload'),
      route: '/identity/sumsub',
    },
    DOCUMENT: {
      name: t('IdentityQueueStore.name.upNextDocUpload'),
      route: '/identity/sumsub',
    },
    SELFIE: {
      name: t('IdentityQueueStore.name.upNextSelfieDocUpload'),
      route: '/identity/sumsub',
    },
  },
};

const EXCEPTION_TO_CLEAR_ROUTES_BY_URLS = ['dlocal', 'confirm-details'];

/**
 * Depending on the BE's call from queue we will require to clear the exisiting
 * queue on the FE and replace it with the new queue.
 * @param {Array} identityRoutes
 * @returns {Boolean}
 */
const toClearRouteByException = (identityRoutes) => identityRoutes.some((route) => EXCEPTION_TO_CLEAR_ROUTES_BY_URLS.some((exception) => (route.url.toLowerCase()).includes(exception)));

/**
 * Leaves first occurence of Sumsub document only and all Banxa provider documents
 * @param {Array} routes
 * @returns {Array}
 */
const filterOneSumsubItem = (routes) => {
  const firstSumsubItem = routes.findIndex(
    (route) => route.provider.toLowerCase() === 'sumsub',
  );

  const filteredRoutes = routes.filter(
    (route, index) => route.provider.toLowerCase() === 'banxa'
      || (route.provider.toLowerCase() === 'sumsub' && index === firstSumsubItem),
  );

  return filteredRoutes;
};

const organizeRoutes = (self, key, value, overrideRoutes, index) => {
  const banxaIdentityPages = Object.keys(IDENTITY_MAPPING_ROUTES.BANXA);
  const sumsubIdentityPages = Object.keys(IDENTITY_MAPPING_ROUTES.SUMSUB);

  // see HE-2329 for data structure changes
  const provider = isObject(value)
    ? value?.provider.toUpperCase()
    : value.toUpperCase();
  const weight = isObject(value) ? value?.weight : index;

  if (!isValueString(provider)) {
    console.error('KYC Provider value is not returned');
    return;
  }

  if (!Object.getOwnPropertyDescriptor(IDENTITY_MAPPING_ROUTES, provider)) {
    console.error(`Wrong provider: ${provider} for identity`);
    return;
  }

  if (
    (provider === 'BANXA' && !banxaIdentityPages.includes(key))
    || (provider === 'SUMSUB' && !sumsubIdentityPages.includes(key))
  ) {
    console.error(`Identity: ${key} has no mapped route for send to`);
    return;
  }

  const { route: url, name } = IDENTITY_MAPPING_ROUTES[provider][key];

  // if identityRoutes has no previous key of route name
  // or sumsub recollection from /status has occured, to allow sumsub
  // based named routes to repopulate route array
  const noNewKeys = !self.identityRoutes.find(
    (route) => route?.name.toLowerCase() === name.toLowerCase()
      && route?.provider.toUpperCase() === provider.toUpperCase(),
  );

  if (noNewKeys) {
    self.identityRoutes.push({
      url,
      provider,
      name,
      weight,
    });

    self.calculateTotalSteps();
  }

  overrideRoutes.push({
    url,
    provider,
    name,
    weight,
  });
};

/**
 * Each document has it's own weight, the lower the weight the higher in priority it is in the array of documents
 * @param {Array} routes
 * @returns {Array}
 */
const sortRoutesByWeight = (documents) => {
  const sortedDocs = documents.sort((docA, docB) => {
    if (docA.weight > docB.weight) return 1;
    if (docA.weight < docB.weight) return -1;
    if (docA?.weight === docB?.weight) return 0;
  });

  return sortedDocs;
};

/**
 * Sorting logic to arrange routes required from Centry based on weights
 * @param {Array} routes
 * @returns {Array}
 */
const sortRoutes = (routes) => {
  const filteredRoutes = filterOneSumsubItem(routes);

  // push Questionnaire 2 before
  const questionnaireTwoIndex = filteredRoutes.findIndex(
    (route) => route.name === 'Dofp Questionnaire 2',
  );

  // // todo likely overkill and to delete this
  // const questionnaireTwoExists = filteredRoutes.find(
  //   (route) => route.name === 'Dofp Questionnaire 2',
  // );

  if (questionnaireTwoIndex === -1) {
    return sortRoutesByWeight(filteredRoutes);
  }

  // ignores weights
  const categoryIndex = filteredRoutes.findIndex(
    (doc) => doc.name === 'Investor Categorisation',
  );
  filteredRoutes.splice(categoryIndex, 0, routes[questionnaireTwoIndex]);
  filteredRoutes.splice(questionnaireTwoIndex + 1, 1);

  return filteredRoutes;
};

export default {
  organizeRoutes,
  sortRoutes,
  filterOneSumsubItem,
  sortRoutesByWeight,
  toClearRouteByException,
};
